
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    name: 'SectionSignInCtaWithIcon',
    components: {
      RegistrationOrLoginDialog: () =>
        import('@/components/candidate/RegistrationOrLoginDialog'),
      OrganizationLoginAndRegistrationDialog: () =>
        import('@/components/organization/LoginAndRegistrationDialog'),
      RichText: () => import('@/components/elements/RichText'),
      CustomBigTitle: () => import('@/components/CustomBigTitle'),
    },
    mixins: [ScreenSize],
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
  };
